module.exports = __webpack_public_path__ + "static/media/shop.5464261b.svg";